import { render, staticRenderFns } from "./borrowerLoanItem.vue?vue&type=template&id=1ab0f49e&scoped=true"
import script from "./borrowerLoanItem.vue?vue&type=script&lang=js"
export * from "./borrowerLoanItem.vue?vue&type=script&lang=js"
import style0 from "./borrowerLoanItem.vue?vue&type=style&index=0&id=1ab0f49e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab0f49e",
  null
  
)

export default component.exports